export default __webpack_public_path__ + "static/media/blp.972eed00.png";